import { LOCALE_ID, NgModule } from '@angular/core';
import { DatePipe, registerLocaleData } from '@angular/common';
import localeAr from '@angular/common/locales/ar';
// registerLocaleData(localeAr);
import { CommonModule } from '@angular/common';

// Helpers
import { FormsModule } from '@angular/forms';



import { RecaptchaModule, RecaptchaSettings, RECAPTCHA_LANGUAGE, RECAPTCHA_SETTINGS } from 'ng-recaptcha';
import { environment } from "public/environments/environment";
import { SharedLibModule } from 'projects/shared/src/lib/shared-lib.module';
import { DirtyCheckGuard } from 'projects/shared/src/helpers/CanDeactivate/dirty-check.guard';
import { FilterSectionComponent } from './components/filter-section/filter-section.component';
import { NgxMatSelectSearchModule } from 'ngx-mat-select-search';
import { CurrentSubscriptionCardComponent } from './components/current-subscription-card/current-subscription-card.component';
import { SubscriptionPlanOptionsComponent } from './components/subscription-plan-options/subscription-plan-options.component';

const directives = [
];

const Components: any[] = [
  FilterSectionComponent,
  SubscriptionPlanOptionsComponent,
  CurrentSubscriptionCardComponent


];

@NgModule({
  declarations: [
    Components,
  ],
  imports: [
    CommonModule,
    NgxMatSelectSearchModule,
    // RecaptchaModule,
    SharedLibModule,
    directives
  ],
  exports: [
    NgxMatSelectSearchModule,

    // RecaptchaModule,
    directives,
    Components,
    SharedLibModule
  ],
  providers: [
    // DatePipe,
    // { provide: LOCALE_ID, useValue: localStorage.getItem('language') === 'ar' ? 'ar-EG' : 'en-US' },
    // DirtyCheckGuard,
    // {
    //   provide: RECAPTCHA_SETTINGS,
    //   useValue: {
    //     siteKey: environment.googleSiteKey,
    //     useValue: localStorage.getItem('language') || 'ar'
    //   } as RecaptchaSettings,
    // },
    // {
    //   provide: RECAPTCHA_LANGUAGE,
    //   useFactory: () => localStorage.getItem('language') || 'ar',
    // },
  ]
})
export class SharedModule { }
